export default __webpack_public_path__ + "static/media/whiteCross.82c828a4.svg";